import { createFileRoute } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { redirectLoader } from './Redirect.$pin.$signInToken';

// For now we re-use the same logic as the desktop redirect
// This may change in the future
export const Route = createFileRoute('/_public/Home/RedirectMobile/$pin/$signInToken')({
    loader: redirectLoader,
    staticData: {
        title: TextKey.SignIn,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
});
